import { useState } from "react";
import { tableEco } from "./data";
import { headers } from "../data";
import "./commonBlock.css";

export default function TableEco() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };
  return (
    <div className="tableEcoBlock">
      <div className="headersBlock">
        <button
          className={`btn btnControlAccordion ${isOpen ? "active" : ""}`}
          onClick={toggleAccordion}
        >
          <h2>{headers[7].header}</h2>
          <span>&times;</span>
        </button>
      </div>
      <div className={`tableContent ${isOpen ? "active" : ""}`}>
        <table className="table tableEco">
          <thead>
            <tr>
              <td>Код вида экономической деятельности</td>
              <td>Наименование вида экономической деятельности</td>
            </tr>
          </thead>
          <tbody>
            {tableEco.map((tableItem) => (
              <tr key={tableItem.num || tableItem.description}>
                <td>{tableItem.num}</td>
                <td>{tableItem.description}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
